<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <edit-user-form v-if="user" :user="user">
          </edit-user-form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import EditUserForm from './UserProfile/EditUserForm.vue'

  export default {
    components: {
      EditUserForm,
    },
    data() {
      return {
        user: null
      }
    },
    mounted() {
      const self = this
       self.$store.dispatch("Users/requestUserShow", self.$route.params.id).then((user)=> {
        self.user = user

        self.$store.dispatch("Users/requestUserMoneyBoxAssignmentIndex", self.$route.params.id).then((data)=> {
          self.$set(self.user, "moneybox_assignments", data.user_moneybox_assignments);
         })

        self.$store.dispatch("Users/requestUserSegmentAssignmentIndex", self.$route.params.id).then((data)=> {
          self.$set(self.user, "segment_assignments", data.user_segment_assignments);
         })
       })
    },
  }

</script>
<style>

</style>
